import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
export function fetchUserInfoNoPortal() {
  return noPortalApiClient.get('/login-verify/user-info');
}